import Vue from 'vue'
import { mapActions } from 'vuex'

import { Services, getServicePathToAPI, joinURLPath, regExp } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

const pathToAPI = getServicePathToAPI(Services.recover)

export default {
  name: 'RecoverTemplate',

  data() {
    return {
      login: undefined,
      password: undefined,

      loading: false,
      passwordVisibility: false,

      validation: undefined,
      state: undefined
    }
  },

  computed: {
    $_key() {
      return this.$route.params?.key
    },

    $_disabled() {
      switch (this.state) {
        case 'request': true
        case 'key': return this.loading || !this.password
        default: return this.loading || !regExp.username.test(this.login)
      }
    },

    isValidationResult() {
      return this.validation === true && this.state === 'request'
    }
  },

  watch: {
    $route: {
      handler() {
        this.checkRecoveryKey()
      },
      deep: true
    }
  },

  mounted() {
    this.checkRecoveryKey()
  },

  beforeDestroy() {
    this.login = undefined
    this.password = undefined
    this.loading = false
    this.validation = undefined
    this.state = undefined
  },

  methods: {
    ...mapActions({
      setToken: 'authentication/setToken',
      setAccountFromToken: 'authentication/setAccountFromToken'
    }),

    showNotification(value) {
      const { type, message, field } = value
      let text = message
      if (type) {
        text = this.getTranslate(`errors.validation.types.${type}`, { field })
      }
      if (text) {
        this.addSnackbar({
          text,
          type: 'error'
        })
      }
    },

    processRecoverError(error) {
      if (!error || typeof error !== 'object') {
        return false
      }

      if (Array.isArray(error.data) && error.data.length) {
        error.data.forEach(this.showNotification)

        return true
      }

      if (error.type || error.field || error.message) {
        this.showNotification({
          type: error.type,
          field: error.field,
          message: error.message
        })

        return true
      }

      return false
    },

    async requestRecover() {
      if (!this.$_disabled) {
        try {
          this.loading = true
          const { ok, result } = await request.create(pathToAPI, { body: { id: this.login } })
          if (ok === true || typeof result === 'string') {
            this.validation = true
            this.state = 'request'
            this.login = undefined
          }
        } catch (error) {
          if (!this.processRecoverError(error)) {
            globalErrorHandler(error)
          }
        } finally {
          this.loading = false
        }
      }
    },

    async checkRecoveryKey() {
      if (this.$_key) {
        try {
          this.loading = true
          const { result } = await request.get(joinURLPath(pathToAPI, this.$_key))
          this.validation = result
          this.state = 'key'
          if (this.validation === false) {
            Vue.router.push({ name: 'login' })
          }
        } catch (error) {
          if (!this.processRecoverError(error)) {
            globalErrorHandler(error)
          }
        } finally {
          this.loading = false
        }
      }
    },

    async changePassword() {
      if (this.password && this.$_key) {
        try {
          this.loading = true
          const { result } = await request.create(joinURLPath(pathToAPI, this.$_key), { body: { password: this.password } })
          this.password = undefined
          this.setToken(result)
          await this.setAccountFromToken()
          Vue.router.push({ name: 'home' })
        } catch (error) {
          if (!this.processRecoverError(error)) {
            globalErrorHandler(error)
          }
        } finally {
          this.loading = false
        }
      }
    }
  },

  render
}
